import { AvailabilityStore } from './AvailabiltyStore';
import { PlanStore } from './PlanStore';
import { generateParamString, PlanStoreSearch } from '@micro-apps/env';
import { mapAccommodationsPagePath } from '@fshr/shared';
import { getConfig } from '@micro-apps/env';
import { format } from 'date-fns/format';
import axios from 'axios';
import get from 'lodash/fp/get';

const {
	RESERVATIONS_SITE_URL,
	PREFERRED_PARTNER_DOMAIN,
	PREFERRED_PARTNER_BFF_BASE_URL,
	NODE_ENV,
	FSHR_PUBLIC_BL_MODE,
} = getConfig(process.env);
export const submitSearch = async (
	planStore: PlanStore,
	availabilityStore: AvailabilityStore,
	availCheckTemplate: string,
	roomFindingMethod: string,
	searchOverride: PlanStoreSearch = {},
	link?: string,
	ppMode?: boolean
) => {
	const isMultiRoom = (planStore.search.rooms?.length || 0) > 1;
	const onPPSearchPage = window.location.pathname.includes('/preferredpartner/search');

	const paramString = generateParamString(
		{ ...planStore.search, ...searchOverride },
		availCheckTemplate,
		roomFindingMethod,
		!!ppMode
	);

	const hotelCode = searchOverride?.hotelCode || planStore.search.hotelCode;
	const embeddedBookingEnabled = await planStore.embeddedBookingEnabled(hotelCode);
	const isABF = await planStore.isABFPage();
	if (
		embeddedBookingEnabled &&
		(planStore?.search?.flexDatesSelected || 0) === 0 &&
		(planStore?.config?.enableMultiRoomBookingOnWww ||
			(planStore?.search?.rooms?.length || 1) <= 1) &&
		(!planStore.search?.promoCode || !planStore.customPromoCode) &&
		availabilityStore.search.locale === 'en'
	) {
		// quick fix to first validation that functional cookies are available on the page
		if (window['OnetrustActiveGroups']?.includes('C0003')) {
			await window.FS?.['DECISION_ENGINE']?.recordSearch({
				property: hotelCode,
				checkin:
					planStore.search?.checkinDate && format(planStore.search?.checkinDate, 'yyyy-MM-dd'),
				checkout:
					planStore.search?.checkoutDate && format(planStore.search?.checkoutDate, 'yyyy-MM-dd'),
				promo: planStore.search.promoCode,
				rooms: planStore.search.rooms,
			});
		}

		if ((isABF && planStore.search.hotelCode === hotelCode) || onPPSearchPage) {
			if (hotelCode !== availabilityStore.search.hotelCode) {
				//switching properties, reset the search before updating
				availabilityStore.resetSearch();
			}
			window.dispatchEvent(new Event('closeCAWDialogs'));
			planStore.updateSearch({
				searchIsDirty: false,
				completedSearch: true,
			});
			availabilityStore.updateSearch({
				hotelCode,
				checkinDate:
					planStore.search?.checkinDate && format(planStore.search?.checkinDate, 'yyyy-MM-dd'),
				checkoutDate:
					planStore.search?.checkoutDate && format(planStore.search?.checkoutDate, 'yyyy-MM-dd'),
				rooms: planStore.search.rooms,
				promoCode: planStore.search.promoCode,
				roomSelections: '', //reset the room selections if we update the search on ABF
				currencyCode:
					planStore.search.currencyCode ||
					availabilityStore.userStore?.preferredCurrency ||
					availabilityStore.search.currencyCode,
			});
		} else {
			const url =
				(mapAccommodationsPagePath(link) ||
					`${location.origin}${
						ppMode
							? `/content/fshr/pages/${planStore.search.locale}/preferredpartner/search`
							: mapAccommodationsPagePath(
									`/content/fshr/pages/${planStore.search.locale}/properties/${
										planStore.getProperty(hotelCode)?.id
									}/accommodations`
								)
					}`) + `?${paramString}&c=t`;
			window.location.assign(new URL(url).href);
		}
	} else {
		const url = `${RESERVATIONS_SITE_URL}/${planStore.search.locale}?${paramString}`;
		window.location.assign(new URL(url).href);
	}
};

export const fetchPreferredPartnerProfileDetails = (
	{ localeIsoCode, signal },
	allowAnonymousOnPP = false
) => {
	if (FSHR_PUBLIC_BL_MODE === 'author') {
		return Promise.resolve();
	}
	return axios({
		signal,
		withCredentials: true,
		headers: {
			'Accept-Language': localeIsoCode,
		},
		url: `${PREFERRED_PARTNER_BFF_BASE_URL}/fetch-profile`,
		method: 'POST',
	})
		.then(res => {
			const profileData = get('data')(res);
			if ((!profileData || profileData.isSessionTimedOut === 'true') && !allowAnonymousOnPP) {
				window.location.assign(
					new URL(`${NODE_ENV === 'development' ? '' : PREFERRED_PARTNER_DOMAIN}`).href
				);
			} else {
				return profileData;
			}
		})
		.catch(() => {
			if (!allowAnonymousOnPP) {
				window.location.assign(
					new URL(`${NODE_ENV === 'development' ? '' : PREFERRED_PARTNER_DOMAIN}`).href
				);
			}
		});
};
